import { render, staticRenderFns } from "./FlightOtherDetails.vue?vue&type=template&id=0b8c1f49"
import script from "./FlightOtherDetails.vue?vue&type=script&lang=js"
export * from "./FlightOtherDetails.vue?vue&type=script&lang=js"
import style0 from "./FlightOtherDetails.vue?vue&type=style&index=0&id=0b8c1f49&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports